import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { handleError } from 'src/app/shared/functions/error-handler';
import { assertTrustedUrl } from 'src/app/shared/functions/validate-url';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { IProviderMeetingDetails } from '../interfaces/pa-meeting-details';
import { IndirectMeetingRequest } from 'src/app/shared/models/indirect-meeting-request';
import { EncounterResponse } from 'src/app/shared/interfaces/encounter-response';
import { IEncounterProviderDetails } from 'src/app/shared/interfaces/encounter-provider-details';
import { IEncounterSubmissionDetail } from 'src/app/shared/interfaces/encounter-submission-detail';
import { IEncounterParticipantDetail } from 'src/app/shared/interfaces/encounter-participant-detail';
import { EncounterDashboardRequest } from '../models/encounter-dashboard-request';
import { IProviderList } from 'src/app/shared/interfaces/provider-list';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class EncounterAttendenceService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public stringDate(dat: Date): string {
    let str: string = '';
    str = str + dat.getFullYear().toString() + '-';

    str = str + (dat.getMonth() + 1).toString() + '-';
    str = str + (dat.getDate() < 10 ? '0' : '') + dat.getDate().toString();

    return str;
  }
  public GetDashboardEncounterList(
    providerSk: string,
    startDate: string,
    endDate: string
  ): Observable<EncounterResponse[]> {
    return this.http
      .get<EncounterResponse[]>(
        `${this.config.apiUrl}/EncounterEntry/GetDashboardEncounterList?providerSk=` +
          encodeURIComponent(providerSk) +
          '&startDate=' +
          encodeURIComponent(startDate) +
          '&endDate=' +
          encodeURIComponent(endDate)
      )
      .pipe(catchError(handleError));
  }

  public allEncountersList(
    payload: EncounterDashboardRequest
  ): Observable<any> {
    return this.http
      .post<any>(
        `${this.config.apiUrl}/EncounterEntry/GetDashboardEncounterListByFilter`,
        payload
      )
      .pipe(catchError(handleError));
  }

public getProviderDetails(
  providerSk: string,
  serviceTypeId: number | null
): Observable<IEncounterProviderDetails> {

  let url: string = assertTrustedUrl(
    `${this.config.apiUrl}/EncounterEntry/GetProviderDetails/${encodeURIComponent(providerSk)}`,
    this.config.apiUrl
  );

  if (!_.isNil(serviceTypeId)) {
    url += `/${encodeURIComponent(String(serviceTypeId))}`;
  }

  return this.http
    .get<IEncounterProviderDetails>(url)
    .pipe(catchError(handleError));
}


  public getSubmissionDetails(
    encounterSk: string
  ): Observable<IEncounterSubmissionDetail[]> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/EncounterEntry/ViewSubmissionDetails/${encodeURIComponent(encounterSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IEncounterSubmissionDetail[]>(url)
      .pipe(catchError(handleError));
  }

  public getPAMeeting(meetingSk: string): Observable<IProviderMeetingDetails> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/ProviderManagement/GetPAMeetingDetails/${encodeURIComponent(meetingSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IProviderMeetingDetails>(url)
      .pipe(catchError(handleError));
  }

  updateIndirectMeeting(payload: IndirectMeetingRequest): Observable<string> {
    return this.http
      .post<string>(
        `${this.config.apiUrl}/EncounterEntry/UpdateIndirectMeetingDetails`,
        payload
      )
      .pipe(catchError(handleError));
  }

  getParticipantDetails(payload: {
    scheduleStudentSks: string[];
    actualStudentSks: string[];
  }): Observable<IEncounterParticipantDetail> {
    return this.http
      .post<IEncounterParticipantDetail>(
        `${this.config.apiUrl}/EncounterEntry/GetParticipantDeatils`,
        payload
      )
      .pipe(catchError(handleError));
  }

  public deleteEncounter(payload: {
    encounterSk: string;
    scheduledDate: string;
  }): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.config.apiUrl}/EncounterEntry/DeleteEncounter`, {
        body: payload,
      })
      .pipe(catchError(handleError));
  }

  public providersList(): Observable<IProviderList[]> {
    return this.http
      .get<IProviderList[]>(
        `${this.config.apiUrl}/EncounterEntry/GetEncounterProviderDropdowns`
      )
      .pipe(catchError(handleError));
  }
}
